/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContactType } from './ContactType';
import {
    ContactTypeFromJSON,
    ContactTypeFromJSONTyped,
    ContactTypeToJSON,
} from './ContactType';

/**
 * A member of a service team
 * @export
 * @interface ServiceTeamMemberRequest
 */
export interface ServiceTeamMemberRequest {
    /**
     * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
     * 
     * @type {string}
     * @memberof ServiceTeamMemberRequest
     */
    rID?: string;
    /**
     * 
     * @type {ContactType}
     * @memberof ServiceTeamMemberRequest
     */
    contactType: ContactType;
}

/**
 * Check if a given object implements the ServiceTeamMemberRequest interface.
 */
export function instanceOfServiceTeamMemberRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "contactType" in value;

    return isInstance;
}

export function ServiceTeamMemberRequestFromJSON(json: any): ServiceTeamMemberRequest {
    return ServiceTeamMemberRequestFromJSONTyped(json, false);
}

export function ServiceTeamMemberRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceTeamMemberRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'rID': !exists(json, 'RID') ? undefined : json['RID'],
        'contactType': ContactTypeFromJSON(json['contactType']),
    };
}

export function ServiceTeamMemberRequestToJSON(value?: ServiceTeamMemberRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'RID': value.rID,
        'contactType': ContactTypeToJSON(value.contactType),
    };
}

